const version = window.OC?.config?.version?.split(".")[0] || "35";
const major = Number.parseInt(version);
const isLegacy32 = major < 32;
const isLegacy34 = major < 34;
const isLegacy35 = major < 35;
export {
  isLegacy32 as a,
  isLegacy35 as b,
  isLegacy34 as i
};
//# sourceMappingURL=legacy-Cy3dCXuB.mjs.map
